import { FC, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CardLoader from '../../components/Loader/Loader';
import ConfirmStaffAccountContext, {
    ConfirmStaffAccountProvider,
    EConfirmStaffAccountUiState,
} from '../../contexts/ConfirmStaffAccountContext';
import PageLayout from '../../layout/PageLayout/PageLayout';
import { ERoutes } from '../../util/constants';
import ConfirmStaffAccountForm from '../../components/ConfirmStaffAccountForm/ConfirmStaffAccountForm';
import ConfirmStaffAccountPhone from '../../components/ConfirmStaffAccountPhone/ConfirmStaffAccountPhone';
import ConfirmStaffAccountPhoneVerify from '../../components/ConfirmStaffAccountPhoneVerify/ConfirmStaffAccountPhoneVerify';
import ConfirmStaffAccountSuccess from '../../components/ConfirmStaffAccountSuccess/ConfirmStaffAccountSuccess';
import ConfirmStaffAccountExpired from '../../components/ConfirmStaffAccountExpired/ConfirmStaffAccountExpired';
import ConfirmStaffAccountExists from '../../components/ConfirmStaffAccountExists/ConfirmStaffAccountExists';
const ConfirmStaffAccountRouter: FC = () => {
    return (
        <Switch>
            <Route path={ERoutes.confirmAccountStaffDetails}>
                <PageLayout>
                    <ConfirmStaffAccountForm />
                </PageLayout>
            </Route>
            <Route path={ERoutes.confirmAccountStaffExists}>
                <PageLayout>
                    <ConfirmStaffAccountExists />
                </PageLayout>
            </Route>
            {/* Temporarily skip phone number validation (WI 1043051) */}
            {/* <Route path={ERoutes.confirmAccountStaffPhone}>
                <PageLayout>
                    <ConfirmStaffAccountPhone />
                </PageLayout>
            </Route>
            <Route path={ERoutes.confirmAccountStaffPhoneVerify}>
                <PageLayout showHeader={false}>
                    <ConfirmStaffAccountPhoneVerify />
                </PageLayout>
            </Route> */}
            <Route path={ERoutes.confirmAccountStaffSuccess}>
                <PageLayout>
                    <ConfirmStaffAccountSuccess />
                </PageLayout>
            </Route>
            <Route path={ERoutes.confirmAccountStaffExpired}>
                <PageLayout>
                    <ConfirmStaffAccountExpired />
                </PageLayout>
            </Route>
        </Switch>
    );
};

const ConfirmStaffAccountUi: FC = () => {
    const { confirmStaffAccountUiState } = useContext(ConfirmStaffAccountContext);
    switch (confirmStaffAccountUiState) {
        case EConfirmStaffAccountUiState.default:
        case EConfirmStaffAccountUiState.queryStringParsed:
            return (
                <PageLayout showHeader={false}>
                    <CardLoader addTopPadding={true} />
                </PageLayout>
            );
        case EConfirmStaffAccountUiState.accountExists:
            return (
                <>
                    <Redirect to={ERoutes.confirmAccountStaffExists} />
                    <ConfirmStaffAccountRouter />
                </>
            );
        case EConfirmStaffAccountUiState.ready:
            return (
                <>
                    <Redirect to={ERoutes.confirmAccountStaffDetails} />
                    <ConfirmStaffAccountRouter />
                </>
            );
        case EConfirmStaffAccountUiState.loading:
        case EConfirmStaffAccountUiState.softError:
            return <ConfirmStaffAccountRouter />;
        // Temporarily skip phone number validation (WI 1043051)
        // case EConfirmStaffAccountUiState.accountCreated:
        //     return (
        //         <>
        //             <Redirect to={ERoutes.confirmAccountStaffPhone} push />
        //             <ConfirmStaffAccountRouter />
        //         </>
        //     );
        // case EConfirmStaffAccountUiState.phoneVerification:
        //     return (
        //         <>
        //             <Redirect to={ERoutes.confirmAccountStaffPhoneVerify} push />
        //             <ConfirmStaffAccountRouter />
        //         </>
        //     );
        case EConfirmStaffAccountUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.confirmAccountStaffSuccess} />
                    <ConfirmStaffAccountRouter />
                </>
            );
        case EConfirmStaffAccountUiState.expired:
            return (
                <>
                    <Redirect to={ERoutes.confirmAccountStaffExpired} />
                    <ConfirmStaffAccountRouter />
                </>
            );
        case EConfirmStaffAccountUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            throw new Error('Confirm Staff Account Ui State Set Incorrectly');
    }
};

const ConfirmStaffAccountScreen: FC = () => {
    return (
        <ConfirmStaffAccountProvider>
            <ConfirmStaffAccountUi />
        </ConfirmStaffAccountProvider>
    );
};

export default ConfirmStaffAccountScreen;
